import { useTranslation } from 'next-i18next';

import { useLinksByUserLocale } from '@phoenix/core/frontend/shared/feature/global-links/use-links-by-user-locale';
import { OverviewSection } from '@phoenix/team-m/dashboard/frontend/ui/overview/overview-section';
import { CatalogueCard } from '@phoenix/team-m/dashboard/frontend/ui/from-the-shop/catalogue-card';

import { useRecommendedProducts } from './use-recommended-products';
import { useCompatibleProducts } from './use-compatible-products';
import { useProductCompatibleBatteries } from './use-product-compatible-batteries';
import { RecommendedProducts } from './recommended-products';
import { CompatibleProducts } from './compatible-products';
import { CompatibleBatteries } from './compatible-batteries';

export const FromTheShopSection = () => {
  const { t } = useTranslation();
  const { products: compatibleProducts } = useCompatibleProducts();
  const { productCompatibleBatteries } = useProductCompatibleBatteries();
  const { products: recommendedProducts, hasEnoughRecommendations } = useRecommendedProducts();

  const { data: links } = useLinksByUserLocale(['product-catalogue-stihl-website-us']);
  const { 'product-catalogue-stihl-website-us': catalogueLink } = links || {};

  return hasEnoughRecommendations || compatibleProducts?.length || productCompatibleBatteries.length ? (
    <OverviewSection headline={t('dashboard_fromTheShop_headline')} dataTestId="from-the-shop">
      {hasEnoughRecommendations && <RecommendedProducts products={recommendedProducts} />}
      <CompatibleProducts products={compatibleProducts} />
      <CompatibleBatteries productCompatibleBatteries={productCompatibleBatteries} />
      <CatalogueCard link={catalogueLink} />
    </OverviewSection>
  ) : null;
};
